import { Component, OnInit } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { ToastrService } from 'ngx-toastr';
import { Global } from 'src/app/_services/global.service';
import cloneDeep from 'lodash/cloneDeep';
import { MmitaAssetService } from 'src/app/_services/mmitaAsset.service';
import { ModalService } from 'src/app/_services/modal.service';
import { BaseComponent } from 'src/app/ui-library/component/base.component';
import { SpecialListItemComponent } from './special-list-item/special-list-item.component';

@Component({
  selector: 'app-library-special-list',
  templateUrl: './library-special-list.component.html',
  styleUrls: ['./library-special-list.component.css']
})
export class LibrarySpecialListComponent extends BaseComponent {
  data: Array<any> = [];

  constructor(
    public global: Global,

    private nzModalService: NzModalService,
    private toastr: ToastrService,
    private mmitaAssetService: MmitaAssetService,
    private modalService: ModalService,
  ) {
    super(global);
  }

  ngOnInit(): void {
    this.setColumnDefs();
  }

  setColumnDefs() {
    this.columnDefs = [
      { headerName: 'Property Key', field: 'propertyKey' },
      {
        headerName: 'Asset List',
        field: 'assetList',
        autoHeight: true,
        cellRenderer: params => {
          return params.value.map(item => {
            const style = item.missing
              ? 'color: red; font-weight: bold; text-decoration: line-through;'
              : '';
            return `<span style="${style}">ID: ${item.id}, Order: ${item.order}</span>`;
          }).join('<br>');
        }
      },
      {
        headerName: 'Action',
        pinned: 'right',
        minWidth: 120,
        cellRenderer: params => {
          return `  <i class="fas fa-fw fa-bars" id="moreDetail" style="margin-right:3px; cursor: pointer;"></i>
                    <i class="fas fa-fw fa-edit text-primary" id="editDetail" style="margin-right:3px; cursor: pointer;"></i>
                    <i class="fas fa-fw fa-trash grid-btn-icon text-danger" id="delete" style="margin-right:3px; cursor: pointer;"></i>`;
        },
        onCellClicked: params => {
          switch (params.event.target.id) {
            case 'moreDetail':
              this.modalService.showDetail(params.data, 'Event Category Detail')
              break;
            case 'editDetail':
              this.showItem(params?.data, params.node.rowIndex)
              break
            case 'delete':
              this.modalService.createNzDeleteModal(() => this.deleteRow.call(this, params?.data?.propertyKey))
              break;
          }
        },
      }
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.loadSpecialList();
  }

  loadSpecialList() {
    this.mmitaAssetService.getEventCategories().subscribe(res => {
      this.data = this.formatToArray(res);
    })

  }

  formatToArray(obj: any): any[] {
    return Object.keys(obj).map(key => ({
      propertyKey: key,
      assetList: obj[key]
    }));
  }

  formatToObject(arr: any[]): any {
    const result: any = {};
    arr.forEach(item => {
      result[item.propertyKey] = item.assetList;
    });
    return result;
  }

  showItem(data?: any, rowIndex?: number) {
    const modal = this.nzModalService.create({
      nzContent: SpecialListItemComponent,
      nzWidth: '800px',
      nzTitle: data ? 'Edit Event Category' : 'Add Event Category',
      nzBodyStyle: {
        'max-height': '70vh',
        'overflow-y': 'auto',
      },
      nzComponentParams: { data },
      nzFooter: [
        {
          label: 'Save',
          type: 'primary',
          onClick: () => {
            const instance = modal.getContentComponent();
            const formData = instance.formGroup.value;

            if (!formData || !formData.propertyKey || !formData.assetList) {
              this.toastr.error('Invalid data');
              return false; // 阻止关闭
            }

            if (data) {
              this.editRow(formData, rowIndex);
            } else {
              this.addRow(formData);
            }
          }
        },
        {
          label: 'Cancel',
          onClick: () => modal.close()
        }
      ]
    });
  }



  addRow(newData: any) {
    const _data = cloneDeep(this.data); // 深拷贝原始数据
    _data.push(newData); // 添加新项
    this.submitSpecialList(_data); // 提交新数据
  }

  editRow(updatedData: any, index: number) {
    if (index >= 0 && index < this.data.length) {
      const _data = cloneDeep(this.data); // 深拷贝原始数据
      _data[index] = updatedData; // 替换指定索引的数据
      this.submitSpecialList(_data); // 提交新数据
    }
  }

  deleteRow(propertyKey: string) {
    this.mmitaAssetService.deleteEventCategory(propertyKey).subscribe(() => {
      this.toastr.success('delete successfully');
      this.loadSpecialList()
    })
  }


  submitSpecialList(_data) {
    const formatted = this.formatToObject(_data);
    this.mmitaAssetService.updateEventCategories(formatted).subscribe({
      next: res => {
        this.nzModalService.closeAll();
        this.toastr.success('Submitted successfully');
        this.loadSpecialList();
      },
      error: err => {
        if (err?.error?.message) {
          const missingIds = this.extractMissingIds(err.error.message);
          this.highlightMissingAssets(missingIds);
          this.toastr.error('Some assets were not found and have been highlighted.');
        } else {
          this.toastr.error('Submission failed');
        }
      }
    });
  }

  extractMissingIds(message: string): string[] {
    const regex = /\[([^\]]+)\]/;
    const match = message.match(regex);
    if (match && match[1]) {
      return match[1].split(',').map(id => id.trim());
    }
    return [];
  }

  highlightMissingAssets(missingIds: string[]) {
    this.gridApi.forEachNode((node) => {
      const assetList = node.data.assetList;
      const hasMissing = assetList.some(asset => missingIds.includes(asset.id));
      if (hasMissing) {
        node.setDataValue('assetList', assetList.map(asset => ({
          ...asset,
          missing: missingIds.includes(asset.id)
        })));
      }
    });
  }



}
